import { HomePage } from './HomePage';
import { faHome } from '@fortawesome/free-solid-svg-icons';

export type HomePageRoutes = Record<
    (
        `w/${string}/home`
    ),
    RouteProps
>;

const routes: HomePageRoutes = {
    'w/:wallet_id/home': {
        path: 'w/:wallet_id/home',
        title: 'Home',
        mainPage: true,
        component: HomePage,
        auth: true,
        exact: true,
        showTab: true,
        icon: faHome,
    },
};

export default routes;
